import { ItemStatus } from '@/app/utils/constants/ItemStatus';
import { getItem, getLocalType } from '@/app/utils/toolkit/defaultItems';

export default {
  name: 'fund-review',
  data: () => ({
    loadingExit: false,
    loadingContinue: false,
  }),
  computed: {
    canEdit() {
      const canEditFund = this.$store.getters['fund/canEditActiveFund'] || false;
      const accountID = this.$store.getters['account/getActiveAccount'].uuid;
      const appPermissions = this.$store.getters['account/getAppPermissions'] || [];
      const toolkitAppPermission = appPermissions.filter(app => app.appName === 'TOOLKIT')[0];
      return toolkitAppPermission.status === 'ACTIVE' && (accountID === this.fund.permissions.accountID || canEditFund);
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    trusteeLabel() {
      return this.fund.trustee.type === 'individual' ? 'Trustee(s): ' : 'Director(s)';
    },
    itemType() {
      return this.$store.getters['toolkit/getItemType'];
    },
  },
  methods: {
    saveItem() {
      if (this.fund.status === ItemStatus.STARTED) {
        this.$store.dispatch('fund/updateFundStatus', ItemStatus.IN_PROGRESS);
        this.$store.dispatch('toolkit/updateItemKey', {
          uuid: this.fund.uuid,
          accountID: this.$store.getters['account/getActiveAccount'].uuid,
          relation: this.$store.getters['account/getActiveAccount'].uuid,
          cognitoID: this.fund.permissions.cognitoID,
          status: this.fund.status,
        });
      }
      return this.$store.dispatch('fund/saveFund');
    },
    handleExitClick() {
      this.loadingExit = true;
      this.$mixpanel.track('Toolkit Item', {
        status: 'Fund Complete',
        action: 'Exit',
        type: this.itemType,
        uuid: this.fund.uuid,
      });
      this.saveItem().then(() => {
        if (this.itemType === 'RENT_RELIEF') {
          this.$router.push({ name: 'covid-dashboard' });
        } else if (this.itemType === 'INVESTMENT_STRATEGY_REVIEW') {
          this.$router.push({ name: 'inv-strat-review-dashboard' });
        } else if (this.itemType === 'PENSION_ESTABLISHMENT') {
          this.$router.push({ name: 'pension-establishment-dashboard' });
        } else {
          this.$router.push({ name: 'inv-strat-dashboard' });
        }
      })
        .catch(() => {
          this.loadingExit = false;
        });
    },
    handleContinueClick() {
      this.loadingContinue = true;
      this.$mixpanel.track('Toolkit Item', {
        status: 'Fund Complete',
        action: 'Continue',
        type: this.itemType,
        uuid: this.fund.uuid,
      });
      if (this.fund.status === 'COMPLETE') {
        this.$router.push({
          name: getItem(getLocalType(this.itemType)).route,
          params: { step: getItem(getLocalType(this.itemType)).reviewPage },
        }).catch(() => {
          this.loadingContinue = false;
        });
        return;
      }
      this.saveItem().then(() => {
        const { route } = getItem(getLocalType(this.itemType));
        this.$router.push({ name: route });
      })
        .catch(() => {
          this.loadingContinue = false;
        });
    },
    handleStepClick(step) {
      let revisedStep = step;
      if (this.$store.getters['account/hasIntegrationTokens']) {
        revisedStep += 1;
      }
      this.$emit('stepChange', revisedStep);
    },
  },
};
